export const NFTURLItems = {
  NFT_DETAIL: '/nft-detail'
}